import workspaceQuery from '../../queries/customer/CustomerPriceListWorkspaceQuery.graphql';
import CustomerPriceListReportMutation from '../../mutations/customer/CustomerPriceListReportMutation.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { ReportType } from '../../schema/p4types';
import { EntityType } from '../../../@types/entityTypes';
import { DocumentNode } from '@apollo/client';

const CustomerPriceList: EntityType & { generation: DocumentNode } = {
  type: 'CustomerPriceWork',
  title: 'Customer Price List',
  defaultReturnUrl: '/menu/Customers/',
  workspace: workspaceQuery,
  workspaceUrl: '/Customers/CustomerPriceList/Workspace',
  screenReference: 'CUSTOMERS_PRICE_LIST',
  operations: ALLOW_VIEW,
  generation: CustomerPriceListReportMutation,
  configuration: {
    reportType: ReportType.CustomerPriceList,
    title: 'Customer Price List Report',
  },
};

export default CustomerPriceList;
